// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1d0FU","actions":"GroupTable_actions__2x3VE","deleteModalFooter":"GroupTable_deleteModalFooter__2aofE"};